// @ts-nocheck


import React from 'react';


import { commonHeaderPanel } from '../../lib';

import RepairTab from './Tab';

export const headerPanel = (props) => {
  const { title, vehiclePlanId } = props;
  return (
    <>
      {commonHeaderPanel({ title, vehiclePlanId })}
      <RepairTab vehiclePlanId={props.vehiclePlanId} />
    </>);

};
